import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Link,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {PUBLISHING_STAGES_DEFAULT} from '@explorer/util/filters';

const PublishingStageFilter = props => {
  const {t} = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        marginTop: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: 1,
        }}
      >
        <Typography component="span">
          {t('publishingStageFilter.label')}
        </Typography>
        <Link
          color="inherit"
          underline="always"
          variant="caption"
          href="https://docs.planet.com/data/imagery/planetscope/#planetscope-publishing-lifecycle"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('publishingStageFilter.learnMore', 'Learn more')}
        </Link>
      </Box>
      <FormGroup
        aria-label="publishing-stage"
        name="publishingStageFilter"
        sx={{marginLeft: 0.5}}
        data-qe="publishing-stage-filter"
      >
        {Object.keys(PUBLISHING_STAGES_DEFAULT).map(stage => (
          <Box key={`filter-stage-${stage}`}>
            <FormControlLabel
              value={stage.id}
              checked={!!props.stages[stage]}
              control={
                <Checkbox
                  color="primary"
                  name={stage}
                  onChange={props.onChange}
                  data-qe={`${stage}-stage-checkbox`}
                />
              }
              label={t(`publishingStageFilter.stages.${stage}`)}
              data-qe="publishing-stage-checkbox"
            />
          </Box>
        ))}
      </FormGroup>
    </Box>
  );
};

PublishingStageFilter.propTypes = {
  stages: PropTypes.object,
  onChange: PropTypes.func,
};

export default PublishingStageFilter;
